import {
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase/firebase";
import { resolveWebsiteCatalogItem } from "./catalogImageVariants";

function mapCurrentDesign(document) {
  const data = document.data();

  return resolveWebsiteCatalogItem({
    id: document.id,
    garmentId: String(data.garmentId ?? "").trim(),
    garmentName: String(data.garmentName ?? "").trim(),
    name: String(
      data.designName ??
      data.name ??
      "StichB Design"
    ).trim(),
    description: String(data.description ?? "").trim(),
    images: Array.isArray(data.images) ? data.images : [],
    storagePath: String(data.storagePath ?? "").trim(),
    isActive:
      typeof data.active === "boolean"
        ? data.active
        : data.isActive !== false,
    displayOrder: Number(data.displayOrder ?? 0),
    basePrice: Number(data.basePrice ?? data.startingPrice ?? 0),
    source: "garment_designs",
    recommendedFabricTypeIds: Array.isArray(data.recommendedFabricTypeIds) ? data.recommendedFabricTypeIds.map(String) : [],
    fabricRequirements: Array.isArray(data.fabricRequirements) ? data.fabricRequirements : [],
  });
}

function mapLegacyDesign(document) {
  const data = document.data();

  return resolveWebsiteCatalogItem({
    id: `legacy:${document.id}`,
    garmentId: String(data.sectionId ?? "").trim(),
    name: String(data.name ?? "StichB Design").trim(),
    description: String(data.description ?? "").trim(),
    images: Array.isArray(data.images) ? data.images : [],
    isActive:
      typeof data.isActive === "boolean"
        ? data.isActive
        : true,
    displayOrder: Number(data.displayOrder ?? 0),
    basePrice: Number(data.basePrice ?? data.startingPrice ?? 0),
    source: "design_gallery",
    recommendedFabricTypeIds: Array.isArray(data.recommendedFabricTypeIds) ? data.recommendedFabricTypeIds.map(String) : [],
    fabricRequirements: Array.isArray(data.fabricRequirements) ? data.fabricRequirements : [],
  });
}

export function listenToDesignsByGarment(
  garmentId,
  onSuccess,
  onError
) {
  const normalizedGarmentId = String(garmentId ?? "").trim();

  if (!normalizedGarmentId) {
    onSuccess([]);
    return () => {};
  }

  let currentDesigns = [];
  let legacyDesigns = [];

  const emitCombined = () => {
    const combined = [...currentDesigns, ...legacyDesigns]
      .filter(
        (design) =>
          design.isActive !== false &&
          design.imageUrl.trim().length > 0
      )
      .sort((first, second) => {
        const orderDifference =
          Number(first.displayOrder ?? 0) -
          Number(second.displayOrder ?? 0);

        if (orderDifference !== 0) {
          return orderDifference;
        }

        return first.name
          .toLowerCase()
          .localeCompare(second.name.toLowerCase());
      });

    onSuccess(combined);
  };

  const currentQuery = query(
    collection(db, "garment_designs"),
    where("garmentId", "==", normalizedGarmentId)
  );

  const legacyQuery = query(
    collection(db, "design_gallery"),
    where("sectionId", "==", normalizedGarmentId)
  );

  const unsubscribeCurrent = onSnapshot(
    currentQuery,
    (snapshot) => {
      currentDesigns = snapshot.docs.map(mapCurrentDesign);
      emitCombined();
    },
    onError
  );

  const unsubscribeLegacy = onSnapshot(
    legacyQuery,
    (snapshot) => {
      legacyDesigns = snapshot.docs.map(mapLegacyDesign);
      emitCombined();
    },
    onError
  );

  return () => {
    unsubscribeCurrent();
    unsubscribeLegacy();
  };
}
